import { Skeleton } from '@/components/ui/skeleton';
import { CardListSkeleton } from '@/components/ui/card-list-skeleton';

export function ProjectsPageSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header section */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="space-y-1">
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-32" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
          <Skeleton className="h-4 w-56" />
        </div>
        <Skeleton className="h-10 w-36 rounded-md" />
      </div>

      {/* Project accordions */}
      <CardListSkeleton 
        variant="list" 
        cardTemplate="project" 
        count={3} 
      />
    </div>
  );
}
